
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMusic = props => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  viewBox: "0 0 13 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.974 1.711 6.35.024a.562.562 0 0 0-.724.538v7.612a3.375 3.375 0 1 0 1.125 2.513V4.693l4.9 1.47a.562.562 0 0 0 .725-.538V2.25a.562.562 0 0 0-.4-.539ZM3.375 12.937a2.25 2.25 0 1 1 0-4.499 2.25 2.25 0 0 1 0 4.5ZM11.25 4.87l-4.5-1.35v-2.2l4.5 1.353v2.197Z",
  fill: "var(--fill-0, white)"
})));

      const __svgRaw = "<svg preserveAspectRatio=\"none\" width=\"100%\" height=\"100%\" overflow=\"visible\"  viewBox=\"0 0 13 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path id=\"Vector\" d=\"M11.9742 1.71125L6.34922 0.0237485C6.26524 -0.00146059 6.17653 -0.00668731 6.09017 0.00848563C6.0038 0.0236586 5.92219 0.0588109 5.85183 0.111136C5.78147 0.163462 5.72431 0.231512 5.68493 0.309853C5.64555 0.388195 5.62503 0.474659 5.625 0.562342V8.17437C5.04893 7.65912 4.31348 7.3572 3.54154 7.31906C2.76961 7.28092 2.00798 7.50888 1.38393 7.96484C0.759876 8.42079 0.311223 9.07712 0.112951 9.82413C-0.085322 10.5711 -0.0212017 11.3636 0.294596 12.069C0.610393 12.7744 1.15873 13.35 1.84797 13.6997C2.53721 14.0494 3.32559 14.152 4.08135 13.9902C4.83711 13.8285 5.51445 13.4122 6.00018 12.811C6.48591 12.2099 6.7506 11.4602 6.75 10.6873V4.6932L11.6508 6.16344C11.7348 6.18865 11.8235 6.19387 11.9098 6.1787C11.9962 6.16353 12.0778 6.12837 12.1482 6.07605C12.2185 6.02372 12.2757 5.95567 12.3151 5.87733C12.3545 5.79899 12.375 5.71253 12.375 5.62484V2.24984C12.375 2.12891 12.336 2.01122 12.2638 1.9142C12.1916 1.81718 12.09 1.74602 11.9742 1.71125ZM3.375 12.9373C2.92999 12.9373 2.49498 12.8054 2.12497 12.5581C1.75496 12.3109 1.46657 11.9595 1.29627 11.5484C1.12598 11.1372 1.08142 10.6848 1.16823 10.2484C1.25505 9.81193 1.46934 9.41102 1.78401 9.09635C2.09868 8.78168 2.49959 8.56739 2.93605 8.48058C3.37251 8.39376 3.82491 8.43832 4.23604 8.60861C4.64717 8.77891 4.99857 9.0673 5.24581 9.43731C5.49304 9.80732 5.625 10.2423 5.625 10.6873C5.625 11.2841 5.38795 11.8564 4.96599 12.2783C4.54403 12.7003 3.97174 12.9373 3.375 12.9373ZM11.25 4.86898L6.75 3.51898V1.3182L11.25 2.67172V4.86898Z\" fill=\"var(--fill-0, white)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/music.167ace1a7f6e43c654cbe594a020e520.svg"),
        {
          React: SvgMusic,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      